import { component } from 'picoapp'
import '@/lib/jquery-global.js';
import 'slick-carousel';

export default component((node, ctx) => {

    const arr = node.querySelectorAll('.js-slide')

    const next = node.querySelector('.js-next')
    const prev = node.querySelector('.js-prev')

    function prevItem() {
        if (i === 0) { // i would become 0
            i = arr.length; // so put it at the other end of the array
        }
        i = i - 1; // decrease by one
        return arr[i]; // give us back the item of where we are now
    }

    function nextItem() {
        i = i + 1; // increase i by one
        i = i % arr.length; // if we've gone too high, start from `0` again
        return arr[i]; // give us back the item of where we are now
    }

    var curr = 1;

    // next.addEventListener('click', function() {
    //     node.querySelector('.js-slide[data-slide="' + curr + '"').classList.add('active')

    //     curr = curr + 1;

    //     if (curr == arr.length) {
    //         curr = 0;

    //         jQuery('.js-slide').removeClass('active')
    //     }

    //     console.log(curr)
    // })

    // prev.addEventListener('click', function() {
    //     node.querySelector('.js-slide[data-slide="' + curr + '"').classList.remove('active')

    //     if (curr == 0) {

    //     } else {
    //         curr = curr - 1;
    //     }

    //     console.log(curr)
    // })

    if (node.querySelector('.js-slideshow')) {
        const slider = jQuery(node.querySelector('.js-slideshow'))
  
        slider.slick({
            dots: false,
            arrows: true,
            nextArrow: jQuery('.js-next'),
            prevArrow: jQuery('.js-prev'),
            draggable: true,
            swipe: true,
            infinite: true,
            speed: 500,
            fade: true,
            cssEase: 'linear'
        });
    }

})
